import { ContainerAppUi } from '@/componentes/ContainerAppUi'
import { usePrivacidadeGet } from '@/hooks/API/usePrivacidadeGet'
import { useContextoOutletLayoutComNavegação } from '@/hooks/useLayoutComNavegação'
import { Loader2 } from 'lucide-react'

export const PrivacidadePágina = () => {
  useContextoOutletLayoutComNavegação({
    título: 'Privacidade',
    isBotãoEsquerdo: true,
  })
  const { data } = usePrivacidadeGet()

  return (
    <ContainerAppUi>
      {data ? (
        <div
          className='termAndPrivacy flex w-full flex-col gap-3'
          dangerouslySetInnerHTML={{
            __html: data ?? 'carregando ...',
          }}
        />
      ) : (
        <div className='flex w-full items-center justify-center gap-3'>
          <p className='text-base'>carregando</p>
          <Loader2 className='animate-spin' />
        </div>
      )}
    </ContainerAppUi>
  )
}
